import { useSwitchTransition } from '..';
export function SwitchTransition({
  state,
  timeout,
  mode,
  children
}) {
  const transition = useSwitchTransition(state, timeout, mode);
  return transition(children);
}